<template>
  <div class="pd-y-5 text-left">
    <div v-for="(item, indexSubject) in subjectsList" :key="item._id">
      <h4 class="mg-b-less">วิชาที่ {{ item.index }} {{ item.name }}</h4>
      <div class="flex-display ai-center column-mobile mg-t-5 color-gray text-font-14">
        <p >
          ผู้สอน {{ item.instructor }}
        </p>
        <p class="mg-x-5"><i class="fas fa-clock "></i> เวลาเรียน
          {{getTotaltimeCourse(item.totalStudyTime)}}
          ชั่วโมง</p>
       </div>
      <p v-if="item.description && item.description != '<p><br></p>'">คำอธิบายรายวิชา</p>
      <viewer v-if="item.description && item.description != '<p><br></p>'" :initialValue="item.description" />
      <el-collapse
        v-model="activeAdjunct"
        class="not-border-t"
        :class="{ 'not-border-b': indexSubject == subjectsList.length - 1 }"
      >
        <el-collapse-item
          :title="isOpenAdjunct(indexSubject) ? 'ย่อ' : 'รายละเอียดวิชา'"
          :name="indexSubject"
          class="secondary"
        >
          <div
            v-for="(adjunct, index) in getAdjunctList(item)"
            :key="index"
            class="flex-display ai-center"
          >
            <div>
              <div
                class="circle-adjunct"
                :style="`background-color: ${
                  adjunct.type == 'file' || adjunct.type == 'qa'
                    ? '#0080e0'
                    : '#ffb800'
                };`"
              >
                <i v-if="adjunct.type == 'file'" class="fas fa-file-alt"></i>
                <i v-if="adjunct.type == 'video'" class="fas fa-play"></i>
                <i v-if="adjunct.type == 'qa'" class="fas fa-comment-alt"></i>
              </div>
            </div>
            <p class="pd-l-4 text-font-16">
              <span v-if="adjunct.type == 'video'" class="text-weight-bold"
                >หัวข้อที่ {{ adjunct.index }} </span
              >{{ adjunct.name }}
            </p>
          </div>
           <div
              v-for="document in item.document"
              :key="document.file"
              class="flex-display ai-center"
            >
              <div>
                <div class="success-box"></div>
              </div>
              <div>
                <div
                  class="circle-adjunct"
                  :style="`background-color: ${'#0080e0'};`"
           
                >
                  <!-- #00B27D -->
                  <i class="fas fa-file-alt"></i>
                </div>
              </div>
              <a

                target="_blank"
                class="pd-l-4 cursor-auto text-font-16 color-black learn"
              >
                {{ document.default }}
              </a>
            </div>
            <div
              v-for="attach in item.attach"
              :key="attach.file"
              class="flex-display ai-center"
            >
              <div>
                <div class="success-box"></div>
              </div>
              <div>
                <div
                  class="circle-adjunct"
                  :style="`background-color: ${'#00B27D'};`"
      
                >
                  <i class="fas fa-play"></i>
                </div>
              </div>
              <a
      
                target="_blank"
                class="pd-l-4 cursor-auto text-font-16 color-black learn"
              >
                {{ attach.default }}
              </a>
            </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import "@toast-ui/editor/dist/toastui-editor-viewer.css";

import { Viewer } from "@toast-ui/vue-editor";

export default {
  components: {
    viewer: Viewer,
  },
  props: {
    courseId: {
      type: String,
      default() {
        return '';
      },
    },
    subjectsList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      activeAdjunct: [],
    };
  },
  methods: {
    getTotaltimeCourse(totalStudyTime) {
      let time = 0
      let hours =
        totalStudyTime && totalStudyTime.hours
          ? totalStudyTime.hours
          : 0;
      let minute =
        totalStudyTime && totalStudyTime.minute
          ? totalStudyTime.minute
          : 0;

      time = time + (hours*60) + minute

      return `${parseInt(time/60)}.${time - (parseInt(time/60) * 60) }`;
    },
    isOpenAdjunct(id) {
      let filter = this.activeAdjunct.filter((filter) => filter == id);
      return filter.length > 0 ? true : false;
    },
    getAdjunctList(subject) {
      let arr = [];
      if (subject.preTest) {
        arr.push({
          name: "แบบทดสอบก่อนเรียน (Pre-test)",
          type: "file",
        });
      }

      for (let index = 0; index < subject.topics.length; index++) {
   
        arr.push({
          index: subject.topics[index].index,
          name: subject.topics[index].topic,
          type: "video",
        });
      }

      if (subject.discussion) {
        arr.push({
          name: "กระดานถาม - ตอบระหว่างเรียน (Discussion Forum)",
          type: "qa",
        });
      }

      if (subject.assignment) {
        arr.push({
          name: "งานที่ได้รับมอบหมาย (Assignment)",
          type: "file",
        });
      }

      if (subject.postTest) {
        arr.push({
          name: "แบบทดสอบหลังเรียน (Post-Test)",
          type: "file",
        });
      }

      return arr;
    },
  },
};
</script>

<style scoped></style>
